module.exports = __webpack_public_path__ + "img/user-question.a09a1b16.svg";